import './LeftPaneButtons.css';
import React, { FC } from 'react';
import { observer } from 'mobx-react-lite';
import { LeftPaneContext } from './LeftPaneContext';
import { Dropdown, DropdownItem } from "../../../components/Dropdown";
import icons from '@vse/icons';
import { ButtonConfig } from "./commandButtonsConfig";


const DropdownButton: FC = () => (<>
  <i className={icons.addPlus}></i>
  Add commands
</>);

export const LeftPaneButtons: FC = observer(() => {
  const { library, commandButtonsConfig } = React.useContext(LeftPaneContext);

  const currentApplication = library.currentApplication;
  const currentSequence = currentApplication.currentSequence;

  const isAppReadOnly = currentApplication.isReadOnly();
  const isAppRunning = currentApplication.active;
  const isMainSequence = currentSequence?.isInitialSequence();
  const isAppMachineApp = library.currentApplication.mIsMachineApp;
  const isDropdownDisabled = (
    isAppReadOnly ||
    isAppRunning ||
    !currentSequence ||
    (isMainSequence && isAppMachineApp)
  );

  const shouldDisableCommand = (item: ButtonConfig): boolean => {
    if (typeof item.disabled === 'function') return item.disabled(library);
    return item.disabled || false;
  };

  return (
    <div className="left-pane-buttons ">
      <div className="add-commands">
        <Dropdown
          className="add-commands-dropdown"
          disabled={isDropdownDisabled}
          button={ <DropdownButton/> }
        >
          { commandButtonsConfig.map((item) => (
            <DropdownItem
              key={ item.text }
              className={ item.className }
              title={ item.tooltip }
              disabled={ shouldDisableCommand(item) }
              onClick={ () => item.onClick(item, library) }
              stayOpenAfterClick
            >
              <i className={ item.icon }></i>
              <span>{ item.text }</span>
            </DropdownItem>
          )) }
        </Dropdown>
      </div>
    </div>
  );
});
